import React from 'react';
import { Menu } from '@storable/canaveral-components';
import LoadingIndicator from '../LoadingIndicator';
import styles from './styles.scss';

const propTypes = {};

const defaultProps = {};

const NavigationPagesMenuItemLoading = () => (
  <Menu.Item componentClass="div">
    <LoadingIndicator className={styles.loadingIndicator} />
  </Menu.Item>
);

NavigationPagesMenuItemLoading.propTypes = propTypes;
NavigationPagesMenuItemLoading.defaultProps = defaultProps;

export default NavigationPagesMenuItemLoading;
